import { useEffect, useId, useRef } from "react"

const HubSpotForm = ({
    portalId,
    formId,
    onFormSubmitted = () => {},
    region = "na1",
    ...props
}) => {
    const reactId = useId()
    const containerId = `hubspot-form-${reactId.replace(/:/g, "")}` // useId() can contain colons, so remove them for a cleaner selector.
    const containerRef = useRef(null)

    useEffect(() => {
        if (!window.hbspt?.forms || !containerRef.current)
            return
        
        containerRef.current.replaceChildren() // if the form remounts for any reason, it will append the new form to whatever is existing. this clears out any old form before creating the new one - rrogers

        window.hbspt.forms.create({
            portalId,
            formId,
            region,
            target: `#${containerId}`,
            onFormSubmitted
        })
    }, [containerId])

    return (
        <div
            {...props}
            id={containerId}
            ref={containerRef} />
    )
}

export default HubSpotForm